<script setup>
import Select from "primevue/select";
import Button from "primevue/button";
import { onMounted, ref } from "vue";
import axios from "axios";
import { usePage } from "@inertiajs/vue3";

const formModel = defineModel('form');
const model = defineModel();

defineProps({
    invalid: Boolean,
})

const page = usePage();
const connectedProviders = page.props.connectedProviders ?? [];

const calendars = ref([]);
const loadingCalendars = ref(false);
const error = ref(false);

const fetchCalendars = (refresh = false) => {
    if (!connectedProviders.length) return;

    loadingCalendars.value = true;
    error.value = false;

    const params = refresh ? '?refresh=true' : '';

    Promise.all(
        connectedProviders.map(provider =>
            axios.get(`/app/forms/available_calendars/${provider}${params}`)
                .then(r => r.data ?? [])
                .catch(() => null)
        )
    ).then(results => {
        error.value = results.some(r => r === null);
        calendars.value = results.filter(r => Array.isArray(r)).flat();
    }).finally(() => {
        loadingCalendars.value = false;
    });
};

onMounted(() => fetchCalendars());
</script>

<template>
    <div class="flex gap-2">
        <Select
            v-model="model"
            :placeholder="$t('forms.calendar_placeholder')"
            fluid
            :invalid="invalid"
            :options="calendars"
            option-value="id"
            :loading="loadingCalendars"
        >
            <template #option="{ option }">
                <div class="flex gap-2 items-center">
                    <i class="pi pi-calendar" :style="{ color: option.color }"/>
                    <p>{{ option.name }}</p>
                </div>
            </template>
            <template #value="{ value }">
                <div v-if="value" class="flex gap-2 items-center">
                    <i class="pi pi-calendar" :style="{ color: calendars.find(el => el.id === value)?.color }"/>
                    <p>{{ calendars.find(el => el.id === value)?.name }}</p>
                </div>
            </template>
        </Select>
        <Button
            icon="pi pi-refresh"
            severity="secondary"
            text
            :loading="loadingCalendars"
            @click="fetchCalendars(true)"
            v-tooltip="$t('forms.calendar_refresh')"
        />
    </div>
</template>
